/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';

export const SectionContainerFafaBannerStyled = styled(SectionContainer)`
  ${({ theme }) => {
    let verticalPadding = rem(24);

    if(theme.mediumUp()){
      verticalPadding = rem(30);
    }

    return css`
      &&{
        padding-top: ${verticalPadding};
        padding-bottom: ${verticalPadding};
      }
    `;
  }
}`;
